<mat-card class="example-card">
  <mat-card-header class="py-8 bg-blue-900 text-white flex rounded-t-md">
    <div class="font-bold text-3xl">{{ pageTitle }}</div>
  </mat-card-header>
  <mat-card-content class="border">
    <!------------ bare de chargement ----------------->
    <div *ngIf="exist; else attente"></div>
    <ng-template #attente>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>
    <mat-card>
      <div class="block" style="padding-bottom: 2em">
        <div
          *ngIf="dsReservation && dsReservation.Travel"
          class="grid grid-cols-4 gap-4"
          style="direction: rtl"
        >
          <button
            *ngIf="!standardMode && dsReservation.Travel[0].Travel_statut < 10"
            (click)="calculAll()"
            mat-raised-button
            class="text-white bg-indigo-700 hover:bg-blue-800"
          >
            Calculer
            <mat-icon>exposure</mat-icon>
          </button>
          <button
            *ngIf="!standardMode && dsReservation.Travel[0].Travel_statut == 10"
            [disabled]="!exist || disabled"
            (click)="effacerCalcul()"
            mat-raised-button
            class="text-white bg-red-600"
          >
            Effacer le Calcul
            <mat-icon>delete</mat-icon>
          </button>
          <!-- <button
            [disabled]="!exist || mode != '1'"
            *ngIf="!standardMode"
            (click)="genererListeReservationD()"
            mat-raised-button
            class="colorGreen"
          >
            <mat-icon>settings</mat-icon>
            Générer
          </button> -->
          <!-- <button
            [disabled]="!exist || disabled || travelIsCalculated"
            (click)="goToListeReservation()"
            mat-raised-button
            class="colorBlue"
          >
            <mat-icon>format_list_bulleted</mat-icon>
            Liste réservation
          </button> -->
          <button
            [disabled]="travelIsCalculated"
            (click)="enregistrer()"
            color="primary"
            mat-raised-button
            class="colorGreen bg-gray-300"
          >
            Ajouter Détails
            <mat-icon>save</mat-icon>
          </button>

          <button
            *ngIf="!standardMode"
            (click)="genererStandardCircuit(!standardMode)"
            [disabled]="!(dsReservation.Travel[0].Travel_statut < 10)"
            mat-raised-button
            [class]="
              !(dsReservation.Travel[0].Travel_statut < 10)
                ? 'bg-gray-300 text-gray-500'
                : 'bg-indigo-900 text-white'
            "
            class=""
          >
            Nouveau Modèle
            <mat-icon>flip_to_back</mat-icon>
          </button>

          <button
            *ngIf="standardMode"
            (click)="genererStandardCircuit(!standardMode)"
            mat-raised-button
            class="bg-indigo-500 text-white"
          >
            Retour au circuit
          </button>

          <button
            *ngIf="dsReservation.Travel[0].Travel_statut < 20 && !standardMode"
            [disabled]="
              !exist || disabled || dsReservation.Travel[0].Travel_statut < 10
            "
            mat-raised-button
            (click)="genererDocuments()"
            [class]="
              dsReservation.Travel[0].Travel_statut < 10
                ? 'bg-gray-300'
                : 'bg-indigo-900 text-white'
            "
          >
            Génerer documents
            <mat-icon>assignment</mat-icon>
          </button>

          <button
            [disabled]="dsReservation.Travel[0].Travel_statut != 20"
            mat-raised-button
            (click)="deblockCircuit()"
            [class]="
              dsReservation.Travel[0].Travel_statut != 20
                ? 'bg-gray-300'
                : 'bg-indigo-500 text-white'
            "
          >
            Débloquer Circuit
            <mat-icon>lock_open</mat-icon>
          </button>

          <button
            *ngIf="!standardMode"
            [disabled]="!enregist"
            mat-raised-button
            (click)="openDialogueAlertDup()"
            class="colorBlue"
          >
            Dupliquer
            <mat-icon>library_add</mat-icon>
          </button>

          <button
            *ngIf="!standardMode"
            mat-raised-button
            (click)="openPreviewsRapports()"
            class="bg-indigo-600 duration-300 hover:bg-indigo-700 text-white"
          >
            Imprimer
            <mat-icon>print</mat-icon>
          </button>

          <button
            *ngIf="
              listTravelDToVerifyError && listTravelDToVerifyError.length > 0
            "
            mat-raised-button
            (click)="showVerificationErrorList()"
            class="bg-red-600 text-white"
          >
            SVP verifier ici
            <mat-icon>warning</mat-icon>
          </button>
        </div>

        <div class="grid text-lg">
          <ng-container
            *ngIf="
              totalGlobal != null &&
              totalGlobal.Si != null &&
              totalGlobal.Pi != null &&
              totalGlobal.Sc != null
            "
          >
            <div class="text-sm font-semibold text-red-600 tracking-wider mb-1">
              * Les prix y compris tva + marge
            </div>
            <table
              class="w-full text-sm text-left text-gray-700 dark:text-gray-300"
            >
              <thead
                class="text-xs uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400"
              >
                <tr>
                  <th class="px-1 py-3 bg-red-600 text-white">Total TTC</th>
                  <th class="px-1 py-3 text-gray-700">Prix Individuel TTC</th>
                  <th class="px-1 py-3 text-gray-700">Total Ind</th>
                  <th class="px-1 py-3 text-gray-700">Total Coll</th>
                  <th class="px-1 py-3 text-gray-700">Total Supp</th>
                  <th class="px-1 py-3 text-gray-700">Total Single</th>
                  <th class="px-1 py-3 text-gray-700">Total AGC</th>
                  <th class="px-1 py-3 text-gray-700">Marge</th>
                  <th class="px-1 py-3 text-gray-700">Marge Supp</th>
                  <th class="px-1 py-3 text-gray-700">Marge Single</th>
                  <th class="px-1 py-3 text-gray-700">TVA / Achat</th>
                  <th class="px-1 py-3 text-gray-700">Marge Circuit</th>
                  <th class="px-1 py-3 text-gray-700">TVA / Marge</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="bg-white dark:bg-gray-800 border-t dark:border-gray-600 text-base py-5"
                >
                  <th
                    class="px-1 py-2 font-semibold text-gray-900 dark:text-white text-lg"
                  >
                    {{
                      totalGlobal.totalTTC
                        | currency : "TND" : "symbol" : "1.0-0" : "fr"
                    }}
                  </th>
                  <th class="px-1 py-2 text-gray-700">
                    {{
                      totalGlobal.Pi
                        | currency : "TND" : "symbol" : "1.0-0" : "fr"
                    }}
                  </th>
                  <th class="px-1 py-2 text-gray-700">
                    {{
                      totalGlobal.Si
                        | currency : "TND" : "symbol" : "1.0-0" : "fr"
                    }}
                  </th>
                  <th class="px-1 py-2 text-gray-700">
                    {{
                      totalGlobal.Sc
                        | currency : "TND" : "symbol" : "1.0-0" : "fr"
                    }}
                  </th>
                  <th class="px-1 py-2 text-gray-700">
                    {{
                      totalGlobal.Total_Supp
                        | currency : "TND" : "symbol" : "1.0-0" : "fr"
                    }}
                  </th>
                  <th class="px-1 py-2 text-gray-700">
                    {{
                      totalGlobal.Total_Single
                        | currency : "TND" : "symbol" : "1.0-0" : "fr"
                    }}
                  </th>
                  <th class="px-1 py-2 text-gray-700">
                    {{
                      totalGlobal.frais_staff
                        | currency : "TND" : "symbol" : "1.0-0" : "fr"
                    }}
                  </th>
                  <th class="px-1 py-2 text-gray-700">
                    {{
                      totalGlobal.MargeIndColl
                        | currency : "TND" : "symbol" : "1.0-0" : "fr"
                    }}
                  </th>
                  <th class="px-1 py-2 text-gray-700">
                    {{
                      totalGlobal.MargeSupp
                        | currency : "TND" : "symbol" : "1.0-0" : "fr"
                    }}
                  </th>
                  <th class="px-1 py-2 text-gray-700">
                    {{
                      totalGlobal.MargeSingle
                        | currency : "TND" : "symbol" : "1.0-0" : "fr"
                    }}
                  </th>
                  <th class="px-1 py-2 text-gray-700">
                    {{
                      totalGlobal.tva
                        | currency : "TND" : "symbol" : "1.0-0" : "fr"
                    }}
                  </th>
                  <th class="px-1 py-2 text-gray-700">
                    {{
                      totalGlobal.Marge_Circuit
                        | currency : "TND" : "symbol" : "1.0-0" : "fr"
                    }}
                  </th>
                  <th class="px-1 py-2 text-gray-700">
                    {{
                      totalGlobal.TVA_Marge
                        | currency : "TND" : "symbol" : "1.0-0" : "fr"
                    }}
                  </th>
                </tr>
              </tbody>
            </table>

            <!-- devise Item -->
            <div class="flex gap-4">
              <!-- <mat-form-field appearance="outline" class="width-200">
                <mat-label>Devise</mat-label>
                <mat-select (selectionChange)="selectDevise($event.value)">
                  <mat-option *ngFor="let devi of ListeDevise" [value]="devi">{{devi}}</mat-option>
                </mat-select>
              </mat-form-field> -->
              <!-- <a class="bouton" (click)='showDetailSupp()'>
                <mat-icon style="position: relative;top: 5px; cursor: pointer;">info</mat-icon> Info
              </a> -->
              <a
                class="bouton cursor-pointer bg-blue-600"
                (click)="showDetailCalcul()"
              >
                <mat-icon style="position: relative; top: 5px; cursor: pointer"
                  >info</mat-icon
                >
                Detail Calcul
              </a>
            </div>
          </ng-container>
        </div>
      </div>

      <mat-form-field appearance="outline" class="w-1/3" *ngIf="standardMode">
        <mat-label>Nom modèle</mat-label>
        <input
          matInput
          name="Travel_Nom"
          [(ngModel)]="reservation.Travel_Nom"
          #TravelNom="ngModel"
          placeholder="Nom Standard"
        />
      </mat-form-field>

      <div class="flex gap-4 overflow-auto" *ngIf="!standardMode">
        <mat-form-field appearance="outline" class="width-200">
          <mat-label>Nom Ciruit</mat-label>
          <input
            matInput
            name="Travel_Nom"
            [(ngModel)]="reservation.Travel_Nom"
            #TravelNom="ngModel"
            placeholder="Nom Ciruit"
          />
        </mat-form-field>
        <!-- <mat-form-field appearance="outline" class="width-130">
          <mat-label>Date arrivée</mat-label>
          <input
            [disabled]="disabled"
            (dateChange)="
              dateActionChange('DATEARRIVEE');
              this.generateTravel_Ref(reservation.Tiers_code)
            "
            matInput
            name="Travel_DateDeb"
            #Travel_DateDeb="ngModel"
            [(ngModel)]="reservation.Travel_DateDeb"
            [matDatepicker]="picker1"
            placeholder="Date arrivée"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker1"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field> -->

        <unilog-date-picker
          [label]="'Date arrivée'"
          [style]="{ width: '100%' }"
          [(date)]="reservation.Travel_DateDeb"
          (dateChange)="
            dateActionChange('DATEARRIVEE');
            this.generateTravel_Ref(reservation.Tiers_code)
          "
        >
        </unilog-date-picker>

        <unilog-date-picker
          [label]="'Date de départ'"
          [style]="{ width: '100%' }"
          [(date)]="reservation.Travel_DateFin"
          (dateChange)="
            dateActionChange('DATEDEPART');
            this.generateTravel_Ref(reservation.Tiers_code)
          "
        >
        </unilog-date-picker>
        <!-- <mat-form-field appearance="outline" class="width-130">
          <mat-label>Date de départ</mat-label>
          <input
            [disabled]="disabled"
            (dateChange)="
              dateActionChange('DATEDEPART');
              this.generateTravel_Ref(reservation.Tiers_code)
            "
            matInput
            name="Travel_DateFin"
            #Travel_DateFin="ngModel"
            [(ngModel)]="reservation.Travel_DateFin"
            [matDatepicker]="picker2"
            placeholder="Date départ"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field> -->
        <mat-form-field appearance="outline" class="width-70">
          <mat-label>Nbr.jours</mat-label>
          <input
            [disabled]="mode != '1'"
            matInput
            name="Travel_NbJour"
            [(ngModel)]="reservation.Travel_NbJour"
            type="number"
            min="1"
            #Travel_NbJour="ngModel"
            placeholder="Nbr.jours"
            (keyup)="nbJourChanged()"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="width-70">
          <mat-label>Nbr.Personne</mat-label>
          <input
            [disabled]="disabled"
            matInput
            name="Travel_NbPerso"
            [(ngModel)]="reservation.Travel_NbPerso"
            type="number"
            min="0"
            #Travel_NbPerso="ngModel"
            placeholder="Nbr.Personne"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" class="width-70">
          <mat-label>Tour Leader</mat-label>
          <input
            [disabled]="disabled"
            matInput
            name="Travel_NbAccompagnant"
            [(ngModel)]="reservation.Travel_NbAccompagnant"
            type="number"
            min="0"
            #Travel_NbAccompagnant="ngModel"
            placeholder="Tour Leader"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" class="width-70">
          <mat-label>GUIDE CIRCUIT</mat-label>
          <input
            [disabled]="disabled"
            matInput
            name="Travel_NbGuide"
            [(ngModel)]="reservation.Travel_NbGuide"
            type="number"
            min="0"
            #Travel_NbGuide="ngModel"
            placeholder="GUIDE CIRCUIT"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" class="width-70">
          <mat-label>CHAUFFEURS</mat-label>
          <input
            [disabled]="disabled"
            matInput
            name="Travel_NbChauffeur"
            [(ngModel)]="reservation.Travel_NbChauffeur"
            type="number"
            min="0"
            #Travel_NbChauffeur="ngModel"
            placeholder="GUIDE CIRCUIT"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" class="width-70">
          <mat-label>TVA %</mat-label>
          <input
            [disabled]="disabled"
            matInput
            name="Travel_NbChauffeur"
            [(ngModel)]="reservation.Travel_TVA"
            type="number"
            min="0"
            #Travel_NbChauffeur="ngModel"
            placeholder="GUIDE CIRCUIT"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" class="width-70">
          <mat-label>Marge %</mat-label>
          <input
            [disabled]="disabled"
            matInput
            name="Travel_NbChauffeur"
            [(ngModel)]="reservation.Travel_Marge"
            type="number"
            min="0"
            #Travel_NbChauffeur="ngModel"
            placeholder="GUIDE CIRCUIT"
            [value]="reservation.Travel_Marge || 0"
          />
        </mat-form-field>
      </div>

      <div class="flex gap-4 overflow-auto" *ngIf="!standardMode">
        <app-recherche
          #clientComponent
          [style]="{ width: '170px', 'margin-right': '10px' }"
          [api]="generalService.api"
          [numColonneToShow]="1"
          [numColonneToReturn]="0"
          (ChampEnter)="
            blurClient($event); this.generateTravel_Ref(reservation.Tiers_code)
          "
          recherche="client"
          name="client"
          placeholder="Code Client"
          [(ngModel)]="reservation.Tiers_code"
        >
        </app-recherche>

        <mat-form-field appearance="outline">
          <mat-label>Nature travel</mat-label>
          <mat-select
            [formControl]="typControl"
            [(ngModel)]="reservation.Travel_Type"
            (selectionChange)="
              changeTypTravel($event.value);
              this.generateTravel_Ref(reservation.Tiers_code)
            "
            name="typtra"
          >
            <mat-option *ngFor="let typ of Typtrav" [value]="typ.value">
              {{ typ.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Saison</mat-label>
          <mat-select
            [formControl]="saisonControl"
            [(ngModel)]="reservation.Travel_Saison"
            (selectionChange)="
              changeSaison($event.value);
              this.generateTravel_Ref(reservation.Tiers_code)
            "
            name="sais"
          >
            <mat-option *ngFor="let s of saisons" [value]="s.value">
              {{ s.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="width-150">
          <mat-label>Référence</mat-label>
          <input
            [disabled]="true"
            matInput
            name="Travel_Travel_Ref"
            [(ngModel)]="reservation.Travel_Ref"
            type="text"
            #Travel_Travel_Ref="ngModel"
            placeholder="Référence"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="width-80">
          <mat-label>Version</mat-label>
          <input
            [disabled]="true"
            matInput
            name="Travel_version"
            [(ngModel)]="reservation.Travel_version"
            type="number"
            min="1"
            #Travel_version="ngModel"
            placeholder="Version"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="width-150">
          <mat-label>Date de duplication</mat-label>
          <input
            [disabled]="true"
            matInput
            name="Travel_DateDup"
            #Travel_DateDup="ngModel"
            [(ngModel)]="reservation.Travel_DateDup"
            [matDatepicker]="pickerDup"
            placeholder="Date de duplication"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="pickerDup"
          ></mat-datepicker-toggle>
          <mat-datepicker #pickerDup></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="width-150">
          <mat-label>Origine de duplication</mat-label>
          <input
            [disabled]="true"
            matInput
            name="Travel_origineDup"
            [(ngModel)]="reservation.Travel_origineDup"
            type="text"
            #Travel_origineDup="ngModel"
            placeholder="Origine de duplication"
          />
        </mat-form-field>
      </div>

      <div class="flex" *ngIf="!standardMode">
        <div class="flex items-center w-full">
          <mat-form-field
            appearance="outline"
            class="flex-grow-1"
            style="width: inherit"
          >
            <mat-label>Commentaire</mat-label>
            <textarea
              matInput
              name="Travel_Commentaire"
              rows="1"
              class="w-full"
              [(ngModel)]="reservation.Travel_Commentaire"
              #Travel_Commentaire="ngModel"
              placeholder="Commentaire"
            ></textarea>
          </mat-form-field>
          <button
            *ngIf="mode == 2"
            (click)="updateTravel_commentaire(dsReservation)"
            mat-raised-button
            class="bg-blue-500 text-white rounded-r-lg py-4 ml-6 hover:bg-blue-700"
          >
            &nbsp;
            <i class="fas fa-check"></i>
          </button>
        </div>
      </div>
    </mat-card>
    <div>
      <mat-accordion>
        <mat-expansion-panel
          *ngFor="let myReservationD of listeReservationDetail; let i = index"
          [expanded]="i == lastOpened"
          (opened)="lastOpened = i"
          (click)="verifReadOnly(i)"
          (click)="getIndexJour(i)"
        >
          <mat-expansion-panel-header
            (click)="orderListeReservationDetail(i)"
            class="shadow-md rounded-md transition"
            [class]="i == 0 ? 'bg-blue-700' : 'bg-gray-200'"
          >
            <div class="w-full flex justify-between">
              <span
                class="text-xl font-bold"
                [class]="i == 0 ? 'text-white' : 'text-gray-700'"
                >{{ i == 0 ? "Frais généraux" : "Jour" + i }}
              </span>
              <mat-icon
                *ngIf="i != 0"
                (click)="deleteJour(myReservationD)"
                class="text-red-600"
              >
                delete
              </mat-icon>
            </div>
          </mat-expansion-panel-header>
          <br />
          <div class="card-reservation-d justify-center">
            <app-liste
              #listeConmponent
              [index]="i"
              [showChekcboxes]="true"
              [showFilter]="false"
              [showSort]="false"
              [titre]="titre"
              [listBtn]="
                dsReservation.Travel[0].Travel_statut >= 10
                  ? listBtnOnlyEdit
                  : listBtn
              "
              [usePhoneTemplate]="true"
              [dataSource]="myReservationD.liste"
              [columns]="columns"
              (output)="output($event, listeConmponent, i + 1)"
            >
            </app-liste>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </mat-card-content>
</mat-card>
<ng-template #frmAjout>
  <form #f="ngForm">
    <div class="flex bg-blue-100 rounded-lg p-4 mb-4 text-lg text-blue-700">
      <svg
        class="inline mr-3"
        style="width: 25px; height: 25px"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
          clip-rule="evenodd"
        ></path>
      </svg>
      <div>
        Des problèmes avec les fournisseurs ou les tarifs ?
        <span
          (click)="navigateToFournisseurTable_EasyAcces()"
          class="font-medium hover:underline divide-blue-200 cursor-pointer"
          style="font-weight: 600"
          >aller la gestion des fournisseurs. &nbsp;</span
        >
        <span
          (click)="navigateToTarifsTable_EasyAcces()"
          class="font-medium hover:underline divide-blue-200 cursor-pointer"
          style="font-weight: 600"
          >aller la gestion des tarifs.</span
        >
      </div>
    </div>
    <div class="flex justify-between mb-20 gap-4">
      <span class="text-gray-600 font-semibold text-xl">
        Jour&nbsp;{{ indexJour - 1 }}
      </span>
      <div class="flex items-center gap-2">
        <button
          *ngIf="
            (indexJour != 1 &&
              reservationD.TravelD_TypeEvent != null &&
              reservationD.TravelD_Event != null &&
              reservationD.TravelD_Ville != null &&
              reservationD.Tiers_code != null &&
              reservationD.TravelD_HDeb != null &&
              reservationD.TravelD_Duree != null &&
              reservationD.TravelD_Duree != 0 &&
              reservationD.TravelD_HFin != null &&
              reservationD.Tiers_RS) ||
            (indexJour == 1 &&
              reservationD.TravelD_TypeEvent != null &&
              reservationD.TravelD_Event != null &&
              reservationD.TravelD_Ville != null &&
              reservationD.Tiers_code != null &&
              reservationD.Tiers_RS)
          "
          (click)="ajouterDetailReservation(f)"
          mat-raised-button
          class="colorGreen"
        >
          <mat-icon>done</mat-icon>
          {{ bouton == "ajouter" ? "Ajouter" : "Modifier" }}
        </button>

        <button
          *ngIf="
            (reservationD.TravelD_TypeEvent === 2 &&
              this.reservationD.Tiers_code) ||
            (this.reservationD.Tiers_code &&
              reservationD.TravelD_TypeEvent === 0)
          "
          (click)="getInfoMenuTarif()"
          mat-raised-button
          class="bg-indigo-800 text-white"
        >
          <mat-icon>info_outline</mat-icon>
          info
        </button>
        <button
          (click)="close()"
          mat-raised-button
          class="bg-red-600 text-white"
        >
          <mat-icon>close</mat-icon>
          Fermer
        </button>
      </div>
    </div>

    <mat-form-field appearance="outline" class="width-150 mx-2">
      <mat-label>Prestation</mat-label>
      <mat-select
        (selectionChange)="typeEvennementChange($event.value)"
        name="TravelD_TypeEvent"
        #TravelD_TypeEvent="ngModel"
        [(ngModel)]="reservationD.TravelD_TypeEvent"
        placeholder="Prestation"
      >
        <mat-option
          *ngFor="let t of listeTypeEvennement"
          [value]="t.TravelD_TypeEvent"
          >{{ t.text }}</mat-option
        >
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="width-150 mx-2">
      <mat-label>Type de prestation</mat-label>
      <mat-select
        name="TravelD_Event"
        #TravelD_Event="ngModel"
        [(ngModel)]="reservationD.TravelD_Event"
        placeholder="Type de prestation"
        (selectionChange)="codeEvent($event)"
      >
        <mat-option
          *ngFor="let t of listeEvennementFiltred"
          [value]="t.TravelD_Event"
          >{{ t.TravelD_Event }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <app-recherche
      #villeComponent
      [style]="{ width: '130px', 'margin-right': '10px' }"
      [api]="generalService.api"
      [(ngModel)]="reservationD.TravelD_Ville"
      [numColonneToShow]="1"
      [numColonneToReturn]="0"
      (ChampEnter)="blurVille($event)"
      recherche="apiville"
      name="VILLE"
      placeholder="VILLE"
    >
    </app-recherche>

    <app-recherche
      #fournisseurComponent
      [style]="{ width: '170px', 'margin-right': '10px' }"
      [api]="generalService.api"
      [numColonneToShow]="1"
      [numColonneToReturn]="0"
      (ChampEnter)="blurFournisseur($event)"
      recherche="batfour"
      name="fournisseur"
      [param]="reservationD.TravelD_TypFournisseur"
      [param2]="reservationD.TravelD_Ville"
      placeholder="FOURNISSEUR"
      [ngModel]="reservationD.Tiers_RS"
    >
    </app-recherche>
    <mat-form-field appearance="outline" style="width: 130px">
      <mat-label>{{ TravelD_TypeLabel || "TYPE" }}</mat-label>
      <mat-select
        name="TravelD_Type"
        #TravelD_Type="ngModel"
        [(ngModel)]="reservationD.TravelD_Type"
        placeholder="TYPE"
        (selectionChange)="selectType($event.value)"
      >
        <mat-option *ngFor="let t of listeTypeFiltred" [value]="t.value">{{
          t.text
        }}</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- <div
      *ngIf="
        (reservationD.TravelD_TypeEvent == 2 && this.reservationD.Tiers_code) ||
        (this.reservationD.Tiers_code && reservationD.TravelD_TypeEvent == 0)
      "
      class="flex justify-start space-x-4 my-3 items-center"
    >
      <div class="flex flex-col">
        <span class="text-sm font-semibold text-gray-600 tracking-wide"
          >le Choix est :
        </span>
        <div class="item" style="width: fit-content" *ngIf="menuChoixWithPrice">
          <div class="item__header">
            <h3 class="item__title">{{ menuChoixWithPrice.Code_Menu }}</h3>
            <span class="item__dots"></span>
            <span class="item__price">{{ menuChoixWithPrice.Tarif }}DT</span>
          </div>
          <p class="item__description">{{ menuChoixWithPrice.Detail_Menu }}.</p>
        </div>
      </div>
      <button
        (click)="getInfoMenuTarif()"
        mat-raised-button
        class="bg-indigo-500 text-white"
      >
        <mat-icon>import_contacts</mat-icon>
        Ouvrir le menu
      </button>
    </div> -->

    <div *ngIf="indexJour > 1" class="flex gap-4 items-center my-3">
      <div class="flex flex-col justify-center">
        <div class="text-gray-800 text-center">Heure Début</div>
        <app-time-picker
          [readonly]="ChangeHdeb"
          [format]="'h:m'"
          [(time)]="reservationD.TravelD_HDeb"
          (timeChange)="setTravelD_HFin()"
        >
        </app-time-picker>
      </div>
      <div class="mt-5 text-blue-600 text-2xl">+</div>
      <div class="flex flex-col justify-center">
        <div class="text-gray-800 text-center">Dureé</div>
        <app-time-picker
          [format]="'h:m'"
          [(time)]="reservationD.TravelD_Duree"
          (timeChange)="setTravelD_HFin()"
        >
        </app-time-picker>
      </div>
      <div class="mt-5 text-blue-600 text-2xl">=</div>
      <div class="flex flex-col justify-center">
        <div class="flex justify-center items-center gap-4">
          <div class="flex flex-col gap-1 items-center">
            <div class="text-gray-800 text-center">Heure Fin</div>
            <mat-icon class="text-blue-500 text-2xl cursor-pointer"
              >expand_less</mat-icon
            >
            <input
              type="number"
              class="text-center p-4 text-lg outline-none font-bold border-blue-500 rounded-md border w-52 px-5"
              [readonly]="true"
              id="HourFin"
              name="HourFin"
              [(ngModel)]="HourFin"
            />
            <mat-icon class="text-blue-500 text-2xl cursor-pointer"
              >expand_more</mat-icon
            >
          </div>
          <span style="margin-top: 16%">:</span>
          <div class="flex flex-col items-center" style="margin-top: 18%">
            <mat-icon class="text-blue-500 text-2xl cursor-pointer"
              >expand_less</mat-icon
            >
            <input
              type="number"
              class="text-center p-4 text-lg outline-none font-bold border-blue-500 rounded-md border w-52 px-5"
              [readonly]="true"
              id="MinFin"
              name="MinFin"
              [(ngModel)]="MinFin"
            />
            <mat-icon class="text-blue-500 text-2xl cursor-pointer"
              >expand_more</mat-icon
            >
          </div>
        </div>
      </div>

      <!-- <div class="flex flex-col items-start justify-start ml-20">
        <span class="text-sm font-semibold text-red-500 tracking-wide"
          >Voulez-vous changer l'heure début ?
        </span>
        <mat-slide-toggle name="bloq_heurDeb" [(ngModel)]="ChangeHdeb">
          {{
            ChangeHdeb ? "Débloquer Heure début" : "Bloquer Heure début"
          }}</mat-slide-toggle
        >
      </div> -->
    </div>
    <br />
    <mat-form-field appearance="outline" style="width: 130px" class="mx-2">
      <mat-label>Kilometrage</mat-label>
      <input
        type="number"
        min="0"
        matInput
        name="TravelD_Km"
        #TravelD_Km
        [(ngModel)]="reservationD.TravelD_Km"
        placeholder="Kilometrage"
      />
    </mat-form-field>
    <mat-form-field appearance="outline" style="width: 130px" class="mx-2">
      <mat-label>Durée du transport (minutes)</mat-label>
      <input
        type="number"
        min="0"
        matInput
        name="TravelD_DureeTrajet"
        #TravelD_DureeTrajet
        [(ngModel)]="reservationD.TravelD_DureeTrajet"
        placeholder="Durée du transport (minutes)"
      />
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 130px" class="mx-2">
      <mat-label>Durée du transport (Heures)</mat-label>
      <input
        type="text"
        matInput
        [readonly]="true"
        [value]="
          generalService.ConvertisseurDureeEnChaine_Generic(
            reservationD.TravelD_DureeTrajet
          )
        "
        placeholder="Durée du transport (Heures)"
      />
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 130px" class="mx-2">
      <mat-label>Nombre des voitures</mat-label>
      <input
        type="number"
        min="0"
        matInput
        name="TravelD_NbreVoiture"
        #TravelD_NbreVoiture
        [(ngModel)]="reservationD.TravelD_NbreVoiture"
        placeholder="Nombre des voitures"
      />
    </mat-form-field>
    <br />
    <mat-form-field appearance="outline" class="width-475">
      <mat-label>OBSERVATION</mat-label>
      <textarea
        matInput
        name="TravelD_Obs"
        [(ngModel)]="reservationD.TravelD_Obs"
        #TravelD_Obs="ngModel"
      ></textarea>
    </mat-form-field>
    <mat-form-field appearance="outline" class="width-475">
      <mat-label>OBSERVATION CLIENT</mat-label>
      <textarea
        matInput
        name="TravelD_Obs1"
        [(ngModel)]="reservationD.TravelD_Obs1"
        #TravelD_Obs1="ngModel"
      ></textarea>
    </mat-form-field>
  </form>
</ng-template>

<ng-template #frmDetai>
  <div *ngIf="detailJourCout && detailJourCout.length > 0">
    <div class="flex justify-between">
      <div class="text-2xl font-bold inline-block">
        <span class="text-gray-800"> Evenement : </span>
        <span class="text-blue-800">{{
          lineSelected.TravelD_Event || "indisponible"
        }}</span>
      </div>
      <div class="text-2xl font-bold inline-block">
        <span class="text-gray-800"> Ville : </span>
        <span class="text-blue-800">
          {{ lineSelected.TravelD_Ville || "indisponible" }}</span
        >
      </div>
      <button
        (click)="saveEvent()"
        class="bg-blue-500 hover:bg-blue-600 text-white py-4 px-12 font-bold rounded-md text-2xl"
      >
        Enregistrer
      </button>
    </div>
    <div class="flex text-2xl font-bold justify-between">
      <div class="mr-8">
        <span class="text-gray-800">Total Collective :</span>
        <span class="text-yellow-600">{{
          getTotalInfos("TravelDM_Coll_Modif", "TravelDM_Total_COLL")
        }}</span>
      </div>
      <div>
        <span class="text-gray-800">Total Individuel :</span>
        <span class="text-pink-600">{{
          getTotalInfos("TravelDM_Total_INDModif", "TravelDM_Total_IND")
        }}</span>
      </div>
    </div>
    <div class="py-8 w-full">
      <div class="shadow overflow-auto rounded border-b border-gray-200">
        <table class="w-full bg-white">
          <thead class="bg-gray-800 text-white">
            <tr>
              <th class="text-left uppercase font-semibold text-xs pl-8">
                Type Tarif
              </th>
              <th class="text-left py-3 px-8 uppercase font-semibold text-xs">
                Observation
              </th>

              <th class="text-left uppercase py-3 px-8 font-semibold text-xs">
                Accompagnant
              </th>
              <th class="text-left py-3 px-8 uppercase font-semibold text-xs">
                Guide
              </th>
              <th class="text-left py-3 px-8 uppercase font-semibold text-xs">
                Chauffeur
              </th>

              <th class="text-left py-3 px-8 uppercase font-semibold text-xs">
                Tarif
              </th>

              <th class="text-left py-3 px-8 uppercase font-semibold text-xs">
                Total collective
              </th>
              <th class="text-left py-3 px-8 uppercase font-semibold text-xs">
                Total individuel
              </th>
              <!-- <th class="text-left py-3 px-8 uppercase font-semibold text-xs">
                Marge
              </th> -->
              <th class="text-left py-3 px-8 uppercase font-semibold text-xs">
                Modif Accompagnant
              </th>

              <th class="text-left py-3 px-8 uppercase font-semibold text-xs">
                Modif Guide
              </th>

              <th class="text-left py-3 px-8 uppercase font-semibold text-xs">
                Modif Chauffeur
              </th>
              <th class="text-left px-8 uppercase font-semibold text-xs">
                Modif Tarif
              </th>

              <th class="text-left py-3 px-8 uppercase font-semibold text-xs">
                Modif Individuel
              </th>

              <th class="text-left py-3 px-8 uppercase font-semibold text-xs">
                Modif collective
              </th>

              <!-- <th class="text-left px-8 uppercase font-semibold text-xs">
                Modif Marge
              </th> -->
            </tr>
          </thead>
          <tbody class="text-gray-700">
            <ng-container *ngFor="let detail of detailJourCout; index as i">
              <tr
                *ngIf="detail.TravelDM_SUPP <= 0"
                [class]="i % 2 == 0 ? 'bg-gray-100' : ''"
              >
                <td class="text-center pl-8">
                  {{ detail.Type_Tarif }}
                </td>
                <td class="text-center py-3 px-8">
                  {{ detail.Observation }}
                </td>
                <td class="text-center">
                  {{ detail.TravelDM_Accompagniant }}
                </td>
                <td class="text-center py-3 px-8">
                  {{ detail.TravelDM_guide }}
                </td>
                <td class="text-center">
                  {{ detail.TravelDM_Chauffeur }}
                </td>
                <td class="text-center py-3 px-8">
                  {{ detail.TravelDM_Tarif }}
                </td>
                <td class="text-center">
                  {{ detail.TravelDM_Total_COLL }}
                </td>
                <td class="text-center py-3 px-8">
                  {{ detail.TravelDM_Total_IND }}
                </td>
                <!-- <td class="text-center py-3 px-8">
                  {{ detail.TravelDM_margeModif ? detail.TravelDM_margeModif : detail.TravelDM_Marge }}
                </td> -->
                <td class="text-center py-3 px-8">
                  <input
                    id="accompModif"
                    [readOnly]="!EventCalculated"
                    type="number"
                    [(ngModel)]="detail.TravelDM_AccompModif"
                    class="rounded-md border text-center p-4"
                    style="width: 100px"
                  />
                </td>

                <td class="text-center py-3 px-8">
                  <input
                    id="guideModif"
                    [readOnly]="!EventCalculated"
                    type="number"
                    [(ngModel)]="detail.TravelDM_guideModif"
                    class="rounded-md border text-center p-4"
                    style="width: 100px"
                  />
                </td>

                <td class="text-center py-3 px-8">
                  <input
                    id="chaufModif"
                    [readOnly]="!EventCalculated"
                    type="number"
                    [(ngModel)]="detail.TravelDM_ChauffeurModif"
                    class="rounded-md border text-center p-4"
                    style="width: 100px"
                  />
                </td>

                <td class="text-center px-8">
                  <input
                    id="tarifModif"
                    [readOnly]="!EventCalculated"
                    type="number"
                    [(ngModel)]="detail.TravelDM_Tarif_Modif"
                    class="rounded-md border text-center p-4"
                    style="width: 100px"
                  />
                </td>

                <td class="text-center py-3 px-8">
                  <input
                    id="indivModif"
                    [readOnly]="EventCalculated"
                    type="number"
                    [(ngModel)]="detail.TravelDM_Total_INDModif"
                    class="rounded-md border text-center p-4"
                    style="width: 100px"
                  />
                </td>

                <td class="text-center py-3 px-8">
                  <input
                    id="collModif"
                    [readOnly]="!EventCalculated"
                    type="number"
                    [(ngModel)]="detail.TravelDM_Coll_Modif"
                    class="rounded-md border text-center p-4"
                    style="width: 100px"
                  />
                </td>

                <!-- <td class="text-center px-8">
                  <input id="marge" [readOnly]="!EventCalculated" type="number" [(ngModel)]="detail.TravelDM_margeModif"
                    class="rounded-md border text-center p-4" style="width: 100px" />
                </td> -->
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <div class="overflow-hidden">
        <div class="py-8 text-3xl font-bold flex justify-between">
          <span class="text-gray-800">Liste des Supplement</span>
          <span class="text-blue-700">
            Total :
            {{ getTotalInfos("TravelDM_Supp_Modif", "TravelDM_SUPP") }}</span
          >
        </div>
        <div class="py-8 w-full">
          <div class="shadow overflow-hidden rounded border-b border-gray-200">
            <table class="w-full bg-white">
              <thead class="bg-gray-800 text-white">
                <th class="text-left uppercase font-semibold text-xs pl-16">
                  Type Tarif
                </th>
                <th
                  class="text-left py-3 px-16 uppercase font-semibold text-xs"
                >
                  Observation
                </th>
                <th
                  class="text-left py-3 px-16 uppercase font-semibold text-xs"
                >
                  Supplement
                </th>
                <!-- <th class="text-left py-3 px-16 uppercase font-semibold text-xs">
                  Marge Supplement
                </th> -->
                <th class="text-left uppercase font-semibold text-xs">
                  Modif Supplement
                </th>
                <!-- <th class="text-left uppercase font-semibold text-xs">
                  Modif Marge Supplement
                </th> -->
              </thead>

              <tbody class="text-gray-700">
                <ng-container *ngFor="let detail of detailJourCout; index as i">
                  <tr
                    *ngIf="detail.TravelDM_SUPP > 0"
                    [class]="i % 2 == 0 ? 'bg-gray-100' : ''"
                  >
                    <td class="text-center py-3 px-16">
                      {{ detail.Type_Tarif }}
                    </td>
                    <td class="text-center py-3 px-16">
                      {{ detail.Observation }}
                    </td>
                    <td class="text-center py-3 px-16">
                      {{ detail.TravelDM_SUPP }}
                    </td>
                    <!-- <td class="text-center py-3 px-16">
                      {{detail.TravelDM_margeModif ? detail.TravelDM_margeModif : detail.TravelDM_Marge }}
                    </td> -->
                    <td class="text-center">
                      <input
                        id="suppModif"
                        [readOnly]="!EventCalculated"
                        type="number"
                        [(ngModel)]="detail.TravelDM_Supp_Modif"
                        class="rounded-md border text-center p-4"
                        style="width: 100px"
                      />
                    </td>
                    <!-- <td class="text-center">
                      <input id="margeSupp" [readOnly]="!EventCalculated" type="number"
                        [(ngModel)]="detail.TravelDM_margeModif" class="rounded-md border text-center p-4"
                        style="width: 100px" />
                    </td> -->
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-container
    *ngIf="!EventCalculated && (!detailJourCout || detailJourCout.length <= 0)"
  >
    <div class="w-full text-center text-red-600 text-3xl font-bold mb-12">
      Veuillez cliquer sur le bouton calculer
    </div>
    <!-- <div class="w-full flex justify-center">
      <button
        (click)="close()"
        class="mx-8 text-gray-500 shadow-md py-4 px-12 font-bold rounded-md text-2xl"
      >
        Annuler
      </button>
      <button
        (click)="calculerEvent()"
        class="mx-8 bg-green-500 text-white py-4 px-12 font-bold rounded-md text-2xl"
      >
        Calculer
      </button>
    </div> -->
  </ng-container>
</ng-template>
<ng-template #tableLineDetail>
  <div class="p-6">
    <div class="flex justify-between mb-2">
      <div class="text-2xl font-bold inline-block">
        <span class="text-gray-800"> Evenement : </span>
        <span class="text-blue-800">{{
          lineSelected.TravelD_Event || "indisponible"
        }}</span>
      </div>
      <div class="text-2xl font-bold inline-block">
        <span class="text-gray-800"> Ville : </span>
        <span class="text-blue-800">
          {{ lineSelected.TravelD_Ville || "indisponible" }}</span
        >
      </div>
      <div class="text-2xl font-bold inline-block">
        <span class="text-gray-800"> Fournisseur : </span>
        <span class="text-blue-800">
          {{ lineSelected.Tiers_RS || "indisponible" }}</span
        >
      </div>
    </div>
    <div
      class="flex justify-start mb-2 text-2xl text-red-600 font-semibold m-2"
    >
      <span *ngIf="detailJourCout.length == 1">
        {{
          detailJourCout[0].TravelDM_Total_IND +
            detailJourCout[0].TravelDM_Total_COLL
            | currency : "TND" : "symbol" : "0.0-0" : "fr"
        }}</span
      >

      <span *ngIf="detailJourCout.length > 1">
        {{
          detailJourCout[0].TravelDM_Total_IND +
            detailJourCout[0].TravelDM_Total_COLL +
            detailJourCout[1].TravelDM_Total_IND +
            detailJourCout[1].TravelDM_Total_COLL
            | currency : "TND" : "symbol" : "0.0-0" : "fr"
        }}</span
      >
    </div>
    <!--<div class="overflow-x-auto">
      <table
        *ngFor="let cout of detailJourCout"
        class="min-w-full h-full border-collapse border border-gray-500 text-lg my-2 mb-4"
      >
        <thead class="">
          <tr>
            <th
              class="border border-gray-300 px-4 py-2 bg-gray-400 text-white"
            ></th>
            <th class="border border-gray-300 px-4 py-2 bg-gray-800 text-white">
              IND
            </th>
            <th class="border border-gray-300 px-4 py-2 bg-gray-800 text-white">
              COLL
            </th>
            <th class="border border-gray-300 px-4 py-2 bg-gray-800 text-white">
              SUPP
            </th>
            <th class="border border-gray-300 px-4 py-2 bg-gray-800 text-white">
              SINGLE
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="border border-gray-300 px-4 py-2 bg-gray-700 text-white">
              HT
            </td>
            <td class="border border-gray-300 px-4 py-2 text-center">
              {{
                cout.Montant_HT_IND
                  | currency : "TND" : "symbol" : "0.0-0" : "fr"
              }}
            </td>
            <td class="border border-gray-300 px-4 py-2 text-center">
              {{
                cout.Montant_HT_COLL
                  | currency : "TND" : "symbol" : "0.0-0" : "fr"
              }}
            </td>
            <td class="border border-gray-300 px-4 py-2 text-center">
              {{
                cout.TravelDM_SUPP
                  | currency : "TND" : "symbol" : "0.0-0" : "fr"
              }}
            </td>
            <td class="border border-gray-300 px-4 py-2 text-center">
              {{
                cout.TravelDM_SUPP
                  | currency : "TND" : "symbol" : "0.0-0" : "fr"
              }}
            </td>
          </tr>
          <tr>
            <td class="border border-gray-300 px-4 py-2 bg-gray-700 text-white">
              TVA
            </td>
            <td class="border border-gray-300 px-4 py-2 text-center">
              {{
                cout.Montant_TVA_IND
                  | currency : "TND" : "symbol" : "0.0-0" : "fr"
              }}
            </td>
            <td class="border border-gray-300 px-4 py-2 text-center">
              {{
                cout.Montant_TVA_COLL
                  | currency : "TND" : "symbol" : "0.0-0" : "fr"
              }}
            </td>
            <td class="border border-gray-300 px-4 py-2 text-center">
              {{
                cout.TravelDM_SUPP
                  | currency : "TND" : "symbol" : "0.0-0" : "fr"
              }}
            </td>
            <td class="border border-gray-300 px-4 py-2 text-center">
              {{
                cout.TravelDM_SUPP
                  | currency : "TND" : "symbol" : "0.0-0" : "fr"
              }}
            </td>
          </tr>
          <tr>
            <td class="border border-gray-300 px-4 py-2 bg-gray-700 text-white">
              MARGE
            </td>
            <td class="border border-gray-300 px-4 py-2 text-center">
              {{
                cout.Montant_MARGE_IND
                  | currency : "TND" : "symbol" : "0.0-0" : "fr"
              }}
            </td>
            <td class="border border-gray-300 px-4 py-2 text-center">
              {{
                cout.Montant_MARGE_COLL
                  | currency : "TND" : "symbol" : "0.0-0" : "fr"
              }}
            </td>
            <td class="border border-gray-300 px-4 py-2 text-center">
              {{
                cout.TravelDM_SUPP
                  | currency : "TND" : "symbol" : "0.0-0" : "fr"
              }}
            </td>
            <td class="border border-gray-300 px-4 py-2 text-center">
              {{
                cout.TravelDM_SUPP
                  | currency : "TND" : "symbol" : "0.0-0" : "fr"
              }}
            </td>
          </tr>
          <tr>
            <td
              class="border-2 border-gray-600 px-4 py-2 bg-red-700 text-white text-lg font-bold"
            >
              Total
            </td>
            <td
              class="border-2 border-gray-600 px-4 py-2 text-red-600 font-semibold text-center"
            >
              {{
                cout.TravelDM_Total_IND
                  | currency : "TND" : "symbol" : "0.0-0" : "fr"
              }}
            </td>
            <td
              class="border-2 border-gray-600 px-4 py-2 text-red-600 font-semibold text-center"
            >
              {{
                cout.TravelDM_Total_COLL
                  | currency : "TND" : "symbol" : "0.0-0" : "fr"
              }}
            </td>
            <td
              class="border-2 border-gray-600 px-4 py-2 text-red-600 font-semibold text-center"
            >
              {{
                cout.TravelDM_SUPP
                  | currency : "TND" : "symbol" : "0.0-0" : "fr"
              }}
            </td>
            <td
              class="border-2 border-gray-600 px-4 py-2 text-red-600 font-semibold text-center"
            >
              {{
                cout.TravelDM_SUPP
                  | currency : "TND" : "symbol" : "0.0-0" : "fr"
              }}
            </td>
          </tr>
        </tbody>
      </table> 
    </div>-->
    <div
      class="overflow-x-auto px-5 py-4"
      *ngFor="let event of myNewList.slice(0, -1)"
    >
      <p class="text-2xl font-bold">{{ event.TravelDM_Tiers }}</p>

      <table
        class="min-w-full divide-y-2 divide-gray-200 bg-white text-sm border border-black rounded-md"
      >
        <thead class="ltr:text-left rtl:text-right">
          <tr>
            <th class="whitespace-nowrap px-4 py-2 text-gray-900">
              TYPE TARIF
            </th>
            <th class="whitespace-nowrap px-4 py-2 text-gray-900">
              LIBELLE DEPENSE
            </th>
            <th class="whitespace-nowrap px-4 py-2 text-gray-900">
              NOMBRE PERSONNES
            </th>

            <th class="whitespace-nowrap px-4 py-2 text-gray-900">TAUX</th>
            <th class="whitespace-nowrap px-4 py-2 text-gray-900">
              PRIX UNITAIRE
            </th>
            <th class="whitespace-nowrap px-4 py-2 text-gray-900">TOTAL IND</th>
            <th class="whitespace-nowrap px-4 py-2 text-gray-900">
              TOTAL SUPP
            </th>
            <th class="whitespace-nowrap px-4 py-2 text-gray-900">
              TOTAL COLL
            </th>
            <th class="whitespace-nowrap px-4 py-2 text-gray-900">
              TAUX MARGE
            </th>
            <th class="whitespace-nowrap px-4 py-2 text-gray-900">MARGE</th>
            <th class="whitespace-nowrap px-4 py-2 text-gray-900">TAUX TVA</th>
            <th class="whitespace-nowrap px-4 py-2 text-gray-900">TVA</th>
          </tr>
        </thead>

        <tbody
          *ngFor="let detail of event.INDEventDetails.slice(0, -1)"
          class="divide-y divide-gray-200"
        >
          <tr class="odd:bg-gray-50">
            <th class="whitespace-nowrap px-4 py-2 text-gray-900">IND</th>
            <th class="whitespace-nowrap font-medium px-4 py-2 text-gray-900">
              {{ detail.Tiers_categorie }} {{ detail.Type_Tarif }}
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ reservation.Travel_NbPerso }}
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              1
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ detail.TravelDM_Tarif }}
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ reservation.Travel_NbPerso * detail.TravelDM_Tarif }}
            </th>
            <th
              class="whitespace-nowrap px-4 py-2 font-medium text-gray-700"
            ></th>
            <th
              class="whitespace-nowrap px-4 py-2 font-medium text-gray-700"
            ></th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ detail.Marge }}%
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{
                (reservation.Travel_NbPerso *
                  detail.TravelDM_Tarif *
                  detail.Marge) /
                  100
              }}
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ detail.TVA }}%
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ detail.TVACalcul | number : "1.3-3" }}
            </th>
          </tr>
        </tbody>
        <tbody
          *ngFor="let detail of event.SUPEventDetails.slice(0, -1)"
          class="divide-y divide-gray-200"
        >
          <tr class="odd:bg-gray-50">
            <th class="whitespace-nowrap px-4 py-2 text-gray-900">SUP</th>
            <th class="whitespace-nowrap font-medium px-4 py-2 text-gray-900">
              {{ detail.Tiers_categorie }} {{ detail.Observation }}
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ detail.Ind }}
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              1
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ detail.TravelDM_Tarif }}
            </th>
            <th
              class="whitespace-nowrap px-4 py-2 font-medium text-gray-700"
            ></th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ detail.Ind * detail.TravelDM_Tarif }}
            </th>
            <th
              class="whitespace-nowrap px-4 py-2 font-medium text-gray-700"
            ></th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ detail.Marge }}%
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{
                (detail.Ind * detail.Tarif * detail.Marge) / 100
                  | number : "1.3-3"
              }}
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ detail.TVA }}%
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ detail.TVACalcul | number : "1.3-3" }}
            </th>
          </tr>
        </tbody>
        <tbody
          *ngFor="let detail of event.COLLEventDetails.slice(0, -1)"
          class="divide-y divide-gray-200"
        >
          <tr class="odd:bg-gray-50">
            <th class="whitespace-nowrap px-4 py-2 text-gray-900">COLL</th>
            <th class="whitespace-nowrap px-4 font-medium py-2 text-gray-900">
              {{ detail.Observation }}
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ detail.Ind }}
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ detail.Coll }}
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ detail.TravelDM_Tarif }}
            </th>
            <th class="whitespace-nowrap px-4 py-2 text-gray-900"></th>
            <th class="whitespace-nowrap px-4 py-2 text-gray-900"></th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ detail.TravelDM_Total_COLL }}
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ detail.Marge }}%
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{
                detail.Accompagnant * detail.Tarif * (detail.Marge / 100)
                  | number : "1.3-3"
              }}
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ detail.TVA }}%
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ detail.TVACalcul | number : "1.3-3" }}
            </th>
          </tr>
        </tbody>

        <tr class="bg-blue-300">
          <th
            class="whitespace-nowrap px-4 py-2 font-medium text-gray-700"
          ></th>
          <th class="whitespace-nowrap px-4 py-2 text-gray-900">Total</th>
          <th
            class="whitespace-nowrap px-4 py-2 font-medium text-gray-700"
          ></th>
          <th
            class="whitespace-nowrap px-4 py-2 font-medium text-gray-700"
          ></th>
          <th
            class="whitespace-nowrap px-4 py-2 font-medium text-gray-700"
          ></th>
          <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
            {{
              event.INDEventDetails.length > 0
                ? event.INDEventDetails[event.INDEventDetails.length - 1][
                    "GroupTarif"
                  ]
                : " "
            }}
          </th>
          <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
            {{
              event.SUPEventDetails.length > 0
                ? event.SUPEventDetails[event.SUPEventDetails.length - 1][
                    "TravelDM_Tarif"
                  ]
                : " "
            }}
          </th>
          <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
            {{
              event.COLLEventDetails.length > 0
                ? event.COLLEventDetails[event.COLLEventDetails.length - 1][
                    "TravelDM_Total_COLL"
                  ]
                : " "
            }}
          </th>
          <th
            class="whitespace-nowrap px-4 py-2 font-medium text-gray-700"
          ></th>
          <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
            {{
              (event.INDEventDetails.length > 0
                ? event.INDEventDetails[event.INDEventDetails.length - 1][
                    "MargeCalcul"
                  ]
                : 0) +
                (event.SUPEventDetails.length > 0
                  ? event.SUPEventDetails[event.SUPEventDetails.length - 1][
                      "MargeCalcul"
                    ]
                  : 0) +
                (event.COLLEventDetails.length > 0
                  ? event.COLLEventDetails[event.COLLEventDetails.length - 1][
                      "MargeCalcul"
                    ]
                  : 0) | number : "1.3-3"
            }}
          </th>
          <th
            class="whitespace-nowrap px-4 py-2 font-medium text-gray-700"
          ></th>
          <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
            {{
              (event.INDEventDetails.length > 0
                ? event.INDEventDetails[event.INDEventDetails.length - 1][
                    "TVACalcul"
                  ]
                : 0) +
                (event.SUPEventDetails.length > 0
                  ? event.SUPEventDetails[event.SUPEventDetails.length - 1][
                      "TVACalcul"
                    ]
                  : 0) +
                (event.COLLEventDetails.length > 0
                  ? event.COLLEventDetails[event.COLLEventDetails.length - 1][
                      "TVACalcul"
                    ]
                  : 0) | number : "1.3-3"
            }}
          </th>
        </tr>
      </table>
    </div>
    <div class="overflow-x-auto px-5 py-4">
      <p class="text-4xl font-bold text-red-600">Total</p>
      <table
        class="min-w-full divide-y-2 divide-gray-200 text-2xl bg-white border border-black rounded-md"
      >
        <thead class="ltr:text-left rtl:text-right">
          <tr>
            <th class="whitespace-nowrap px-4 py-2 text-gray-900">
              LIBELLE DEPENSE
            </th>
            <th class="whitespace-nowrap px-4 py-2 text-gray-900">
              TOTAL HT IND
            </th>
            <th class="whitespace-nowrap px-4 py-2 text-gray-900">
              TOTAL HT COLL
            </th>
            <th class="whitespace-nowrap px-4 py-2 text-gray-900">
              TOTAL HT SUP
            </th>

            <th class="whitespace-nowrap px-4 py-2 text-gray-900">MARGE</th>
          </tr>
        </thead>

        <tbody class="divide-y divide-gray-200">
          <tr class="bg-red-200">
            <th class="whitespace-nowrap px-4 py-2 text-gray-900">Total</th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ myNewList[myNewList.length - 1]["Total indiv"] }}
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ myNewList[myNewList.length - 1]["Total Coll"] }}
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ myNewList[myNewList.length - 1]["Total Supp"] }}
            </th>
            <th class="whitespace-nowrap px-4 py-2 font-medium text-gray-700">
              {{ myNewList[myNewList.length - 1]["Marge Sup"] }}
            </th>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>
<ng-template #frmInfo>
  <div>
    <div class="py-8 w-full">
      <div class="overflow-hidden">
        <div class="py-8 text-3xl font-bold flex justify-center mb-5">
          <span class="text-gray-800">{{ TypeEvenment.TravelD_Event }}</span>
        </div>
        <div class="overflow-x-auto rounded border border-gray-300 shadow-sm">
          <table class="min-w-full table-fixed divide-y-2 divide-gray-200">
            <thead class="ltr:text-left rtl:text-right">
              <tr class="font-bold divide-x divide-gray-200 *:text-gray-900">
                <td class="px-3 py-2 whitespace-nowrap">IND</td>
                <td class="px-3 py-2 whitespace-nowrap">COLL</td>
                <td class="px-3 py-2 whitespace-nowrap">SUPP</td>
                <td class="px-3 py-2 whitespace-nowrap">SINGLE</td>
                <td class="px-3 py-2 whitespace-nowrap">STAFF (AGC)</td>
                <td class="px-3 py-2 whitespace-nowrap">MARGE</td>
                <td class="px-3 py-2 whitespace-nowrap">MARGE SUPP</td>
                <td class="px-3 py-2 whitespace-nowrap">MARGE SINGLE</td>
                <td class="px-3 py-2 whitespace-nowrap">TVA/ ACHAT</td>
              </tr>
            </thead>

            <tbody class="divide-y divide-gray-200">
              <tr
                class="divide-x divide-gray-200 *:text-gray-900 first:font-medium"
              >
                <td class="px-3 py-2 whitespace-nowrap">
                  {{
                    (eventPrices.TravelDM_Total_IND
                      ? eventPrices.TravelDM_Total_IND
                      : 0
                    ) | currency : "TND" : "symbol" : "1.0-0" : "fr"
                  }}
                </td>
                <td class="px-3 py-2 whitespace-nowrap">
                  {{
                    (eventPrices.TravelDM_Total_COLL
                      ? eventPrices.TravelDM_Total_COLL
                      : 0
                    ) | currency : "TND" : "symbol" : "1.0-0" : "fr"
                  }}
                </td>
                <td class="px-3 py-2 whitespace-nowrap">
                  {{
                    (eventPrices.TravelDM_SUPP ? eventPrices.TravelDM_SUPP : 0)
                      | currency : "TND" : "symbol" : "1.0-0" : "fr"
                  }}
                </td>
                <td class="px-3 py-2 whitespace-nowrap">
                  {{
                    (eventPrices.TravelDM_Single
                      ? eventPrices.TravelDM_Single
                      : 0
                    ) | currency : "TND" : "symbol" : "1.0-0" : "fr"
                  }}
                </td>
                <td class="px-3 py-2 whitespace-nowrap">
                  {{
                    (eventPrices.Staff_Total ? eventPrices.Staff_Total : 0)
                      | currency : "TND" : "symbol" : "1.0-0" : "fr"
                  }}
                </td>
                <td class="px-3 py-2 whitespace-nowrap">
                  {{
                    (eventPrices.XTravelDM_Marge
                      ? eventPrices.XTravelDM_Marge
                      : 0
                    ) | currency : "TND" : "symbol" : "1.0-0" : "fr"
                  }}
                </td>
                <td class="px-3 py-2 whitespace-nowrap">
                  {{
                    (eventPrices.TravelDM_MargeSUPP
                      ? eventPrices.TravelDM_MargeSUPP
                      : 0
                    ) | currency : "TND" : "symbol" : "1.0-0" : "fr"
                  }}
                </td>
                <td class="px-3 py-2 whitespace-nowrap">
                  {{
                    (eventPrices.TravelDM_MargeSingle
                      ? eventPrices.TravelDM_MargeSingle
                      : 0
                    ) | currency : "TND" : "symbol" : "1.0-0" : "fr"
                  }}
                </td>
                <td class="px-3 py-2 whitespace-nowrap">
                  {{
                    (eventPrices.XTravelDM_TVA ? eventPrices.XTravelDM_TVA : 0)
                      | currency : "TND" : "symbol" : "1.0-0" : "fr"
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #frmDetaiSupp>
  <div>
    <div class="py-8 w-full">
      <div class="overflow-hidden">
        <div class="py-8 text-3xl font-bold flex justify-between">
          <span class="text-gray-800">Liste des Supplement</span>
          <span class="text-blue-700"> Total :{{ detailCoutSupp }} </span>
        </div>
        <div class="py-8 w-full">
          <div class="shadow overflow-hidden rounded border-b border-gray-200">
            <table class="w-full bg-white">
              <thead class="bg-gray-800 text-white">
                <th
                  class="text-left py-3 px-16 uppercase font-semibold text-xs"
                >
                  Fournisseur
                </th>
                <th
                  class="text-left py-3 px-16 uppercase font-semibold text-xs"
                >
                  Observation
                </th>
                <th
                  class="text-left py-3 px-16 uppercase font-semibold text-xs"
                >
                  Supplement
                </th>

                <th class="text-left uppercase font-semibold text-xs">
                  Marge Supplement
                </th>
              </thead>

              <tbody class="text-gray-700">
                <ng-container *ngFor="let detail of detailCout; index as i">
                  <tr
                    *ngIf="detail.TravelDM_SUPP > 0"
                    [class]="i % 2 == 0 ? 'bg-gray-100' : ''"
                  >
                    <td class="text-center py-3 px-16">
                      {{ detail.TravelDM_Tierscode }}
                    </td>
                    <td class="text-center py-3 px-16">
                      {{ detail.Observation }}
                    </td>
                    <td class="text-center py-3 px-16">
                      {{
                        detail.TravelDM_Supp_Modif
                          ? detail.TravelDM_Supp_Modif
                          : detail.TravelDM_SUPP
                      }}
                    </td>
                    <td class="text-center py-3 px-16">
                      {{
                        detail.TravelDM_margeModif
                          ? detail.TravelDM_margeModif
                          : detail.TravelDM_Marge
                      }}
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #frmDetailCalcul>
  <div>
    <div class="py-8 w-full">
      <div class="overflow-hidden">
        <div class="flex justify-between">
          <div class="py-8 text-3xl font-bold flex justify-between">
            <span class="text-gray-800">Détail Calcul</span>
            <!-- <span class="text-blue-700">
            Total :{{detailCoutSupp}}
          </span> -->
          </div>

          <mat-form-field appearance="outline" class="width-200">
            <mat-label>Devise</mat-label>
            <mat-select (selectionChange)="selectDeviseCalcul($event.value)">
              <mat-option *ngFor="let devi of ListeDevise" [value]="devi">{{
                devi
              }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="width-80">
            <mat-label>Coef</mat-label>
            <input
              matInput
              [(ngModel)]="coef"
              (keyup)="convertCalcul(coef)"
              type="number"
              placeholder="Coef"
            />
          </mat-form-field>
        </div>
        <div class="py-8 w-full">
          <div class="shadow overflow-hidden rounded border-b border-gray-200">
            <table class="w-full bg-white">
              <thead class="bg-gray-800 text-white">
                <th
                  class="text-left py-3 px-16 uppercase font-semibold text-xs"
                >
                  Total TTc
                </th>

                <th
                  class="text-left py-3 px-16 uppercase font-semibold text-xs"
                >
                  Nbre de personne
                </th>
                <th
                  class="text-left py-3 px-16 uppercase font-semibold text-xs"
                >
                  Cout total/per
                </th>
                <th
                  class="text-left py-3 px-16 uppercase font-semibold text-xs"
                >
                  TVA Achat
                </th>
                <th
                  class="text-left py-3 px-16 uppercase font-semibold text-xs"
                >
                  Taux de marge (%)
                </th>

                <th
                  class="text-left py-3 px-16 uppercase font-semibold text-xs"
                >
                  marge / circuit
                </th>

                <th
                  class="text-left py-3 px-16 uppercase font-semibold text-xs"
                >
                  Taux de Tva sur marge (%)
                </th>

                <th
                  class="text-left py-3 px-16 uppercase font-semibold text-xs"
                >
                  TVA / marge
                </th>
              </thead>

              <tbody class="text-gray-700">
                <ng-container
                  *ngIf="
                    totalGlobal != null &&
                    totalGlobal.Si != null &&
                    totalGlobal.Pi != null &&
                    totalGlobal.Sc != null &&
                    totalGlobal.Ss != null &&
                    totalGlobal.tva != null
                  "
                >
                  <tr>
                    <td class="text-center font-bold py-3 px-16">
                      {{ totalGlobal.totalTTC.toFixed(3) }}
                      {{ symboleDev }}
                    </td>
                    <td class="text-center font-bold py-3 px-16">
                      {{ reservation.Travel_NbPerso }}
                    </td>
                    <td class="text-center font-bold py-3 px-16">
                      {{ totalGlobal.Pi.toFixed(3) }}
                      {{ symboleDev }}
                    </td>
                    <td class="text-center font-bold py-3 px-16">
                      {{ totalGlobal.tva.toFixed(3) }} {{ symboleDev }}
                    </td>
                    <td class="text-center">
                      <input
                        id="margeSupp"
                        type="number"
                        class="rounded-md border text-center p-4"
                        (blur)="
                          saveTauxMarge(
                            this.dsReservation.Travel[0].Travel_Marge
                          )
                        "
                        [(ngModel)]="dsReservation.Travel[0].Travel_Marge"
                        style="width: 100px"
                        placeholder="[0%-100%]"
                        min="0"
                        max="100"
                      />
                    </td>

                    <td class="text-center font-bold py-3 px-16">
                      {{
                        (
                          (dsReservation.Travel[0].Travel_Marge / 100) *
                            (totalGlobal.Si +
                              totalGlobal.Sc +
                              totalGlobal.frais_staff) +
                          totalGlobal.MargeIndColl
                        ).toFixed(3)
                      }}
                      {{ symboleDev }}
                    </td>

                    <td class="text-center">
                      <input
                        id="margeSupp"
                        type="number"
                        class="rounded-md border text-center p-4"
                        (blur)="saveTauxTVA(dsReservation.Travel[0].Travel_TVA)"
                        [(ngModel)]="dsReservation.Travel[0].Travel_TVA"
                        style="width: 100px"
                        placeholder="[0%-100%]"
                        min="0"
                        max="100"
                      />
                    </td>
                    <td class="text-center font-bold py-3 px-16">
                      {{
                        (
                          (dsReservation.Travel[0].Travel_TVA / 100) *
                          ((dsReservation.Travel[0].Travel_Marge / 100) *
                            (totalGlobal.Si +
                              totalGlobal.Sc +
                              totalGlobal.frais_staff) +
                            totalGlobal.MargeIndColl)
                        ).toFixed(3)
                      }}
                      {{ symboleDev }}
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #frmAlertDup>
  <ng-container class="py-8 w-full rounded-2xl" fxLayout="column">
    <!-- <div fxLayout="row" fxLayoutAlign="center center" class="blue-600"><mat-icon>info_outline</mat-icon></div> -->
    <div fxLayout="row" fxLayoutAlign="center center">
      <mat-icon class="blue-600 max-h-full">content_copy</mat-icon>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <mat-card-title style="color: #1e88e5" class="text-4xl text-center"
        >Voulez vous Dupliquer ?
      </mat-card-title>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <h2 class="text-xl font-bold py-4 blue-600">Es-tu sûr?</h2>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <button
        mat-raised-button
        color="primary"
        [mat-dialog-close]="true"
        cdkFocusInitial
        (click)="dupliquerCircuit2()"
      >
        <mat-icon class="mr-2">check</mat-icon>Oui
      </button>
      <div fxFlex="10"></div>
      <button
        mat-raised-button
        color="warn"
        [mat-dialog-close]="true"
        cdkFocusInitial
        (click)="close()"
      >
        <mat-icon class="mr-2">close</mat-icon>Non
      </button>
    </div>
  </ng-container>
</ng-template>

<ng-template #frmImport>
  <div>
    <div class="py-8 w-full">
      <div class="overflow-hidden">
        <div class="flex relative">
          <!-- list standard -->
          <div>
            <div class="text-2xl font-bold mb-16">List des modèles</div>
            <div class="overflow-y-auto" style="height: 70vh">
              <div *ngFor="let std of listeStandards; index as i">
                <div
                  class="bg-gray-200 px-5 py-2 rounded-lg mb-6 mr-4 font-bold flex justify-center items-center cursor-pointer hover:bg-gray-700 hover:text-white duration-300"
                  [class]="
                    indexModelSelected == i
                      ? 'bg-gray-700 text-white'
                      : 'text-gray-700'
                  "
                  (click)="
                    indexModelSelected = i; getDScircuit(std.Travel_Code)
                  "
                >
                  {{ std.Travel_Nom || "standard" }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="ml-12"
            style="border-left: 1px solid #000; height: 77vh"
          ></div>

          <!-- detail standard -->
          <div class="mx-5 ml-12 w-full">
            <div class="text-2xl font-bold mb-6">Detail modèle</div>

            <div
              *ngIf="!detailStandard || detailStandard.length == 0"
              class="flex rounded-lg p-4 mb-4 text-lg"
              [class]="
                messageInformedForDeailModel
                  ? 'bg-red-100 text-red-700'
                  : 'bg-blue-100 text-blue-700'
              "
            >
              <svg
                class="inline mr-3"
                style="width: 25px; height: 25px"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <div>
                {{
                  messageInformedForDeailModel ||
                    "Cliquer pour afficher le détail !"
                }}
              </div>
            </div>

            <div class="overflow-y-auto" style="height: 70vh">
              <div
                *ngFor="let DetStd of detailStandard"
                class="bg-gray-200 rounded-lg p-16 ml-16 mb-6 hover:bg-gray-300 cursor-pointer"
              >
                <label [for]="DetStd.id">
                  <div class="flex justify-between items-center">
                    <div class="grid p-4">
                      <span class="font-bold text-gray-500">Fournisseur</span>
                      <span class="text-blue-600 font-bold text-lg">
                        {{ DetStd.Tiers_RS }}
                      </span>

                      <span class="font-bold text-gray-500">Type</span>
                      <span class="text-blue-600 font-bold text-lg">
                        {{ DetStd.TravelD_Event }}
                      </span>
                    </div>

                    <div class="grid p-4">
                      <span class="font-bold text-gray-500">Ville</span>
                      <span class="text-blue-600 font-bold text-lg">
                        {{ DetStd.TravelD_Ville }}
                      </span>

                      <span class="font-bold text-gray-500">Observation</span>
                      <span class="text-blue-600 font-bold text-lg">
                        {{ DetStd.TravelD_Obs }}
                      </span>
                    </div>

                    <div class="grid p-4">
                      <div class="w-full text-left mb-4">
                        <div
                          class="w-30 h-30 bg-blue-700 float-right justify-center items-center flex rounded-lg cursor-pointer text-center ml-4"
                        >
                          <input
                            [id]="DetStd.id"
                            name="model_standard"
                            type="checkbox"
                            class="border-gray-300 rounded h-2/3 w-2/3"
                            [value]="DetStd.id"
                            (change)="getStandarChecked($event)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </div>

          <!-- action sur les standards -->

          <div class="absolute top-0 right-0 gap-4">
            <button
              (click)="importStandard()"
              mat-raised-button
              class="colorGreen mr-4"
            >
              <mat-icon>done</mat-icon>
              Import
            </button>
            <button
              (click)="toggleAllModelStandard(!isAllSelectedStandarList)"
              mat-raised-button
              class="mr-4"
              [class]="
                !isAllSelectedStandarList ? 'colorBlue' : 'colorBlueInfo'
              "
            >
              <mat-icon>attachment</mat-icon>
              {{
                !isAllSelectedStandarList ? "sélectionner" : "désélectionner"
              }}
              tous
            </button>
            <button
              (click)="close()"
              mat-raised-button
              class="bg-red-600 text-white"
            >
              <mat-icon>close</mat-icon>
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #frmMenuTarif id="frmMenuTarif">
  <div>
    <div class="w-full">
      <a
        class="flex self-end items-center text-lg font-medium cursor-pointer text-blue-600 hover:underline"
        (click)="navigateToTarifTable_EasyAcces(this.reservationD.Tiers_code)"
        >aller au gestion des tarifs
        <mat-icon class="text-base">launch</mat-icon></a
      >
      <div class="overflow-hidden">
        <div class="flex relative w-fit">
          <div
            *ngIf="
              numTypEvenement == 0 || this.reservationD.TravelD_TypeEvent == 0
            "
            class="menu_info_background"
          >
            <div class="wrapper">
              <div class="flex justify-between w-full">
                <h2 class="menu_info_title">Notre Menu</h2>
                <div class="text-2xl font-bold">
                  Choix :
                  <span class="text-yellow-400">{{ choixMenu || "..." }}</span>
                </div>
              </div>

              <!-- Start Pizza Menu -->
              <div class="menu menu--is-visible">
                <div
                  *ngFor="let detail of ListTarif; index as i"
                  class="item"
                  (click)="rowClickMenu(detail)"
                >
                  <div class="item__header">
                    <h3 class="item__title">{{ detail.Code_Menu }}</h3>
                    <span class="item__dots"></span>
                    <span class="item__price">{{ detail.Tarif }}DT</span>
                  </div>
                  <p class="item__description">{{ detail.Detail_Menu }}.</p>
                </div>
              </div>
              <!-- End Pizza Menu -->
            </div>
          </div>

          <!-- detail standard -->
          <div
            *ngIf="this.reservationD.TravelD_TypeEvent != 0"
            style="width: -webkit-fill-available"
            class="mx-auto px-4 sm:px-6 lg:py-2 lg:px-8"
          >
            <div class="flex space-x-4 items-stretch">
              <span
                class="text-3xl font-extrabold tracking-tight text-gray-900 lg:font-semibold lg:text-4xl"
              >
                Tarif
              </span>
              <a
                class="flex self-end items-center text-lg font-medium cursor-pointer text-blue-600 hover:underline"
                (click)="
                  navigateToTarifTable_EasyAcces(this.reservationD.Tiers_code)
                "
                >aller au gestion des tarifs
                <mat-icon class="text-base">launch</mat-icon></a
              >
            </div>
            <ng-container *ngFor="let detail of ListTarif; index as i">
              <div class="grid grid-cols-1 gap-5 sm:grid-cols-4 mt-4">
                <div class="bg-white overflow-hidden shadow sm:rounded-lg">
                  <div class="px-4 py-5 sm:p-6">
                    <dl>
                      <dt
                        class="text-sm leading-5 font-medium text-gray-500 truncate"
                      >
                        Fournisseur
                      </dt>
                      <dd
                        class="mt-1 text-3xl leading-9 font-semibold text-indigo-600"
                      >
                        {{ detail.Tiers_code }}
                      </dd>
                    </dl>
                  </div>
                </div>
                <div class="bg-white overflow-hidden shadow sm:rounded-lg">
                  <div class="px-4 py-5 sm:p-6">
                    <dl>
                      <dt
                        class="text-sm leading-5 font-medium text-gray-500 truncate"
                      >
                        IND_COLL
                      </dt>
                      <dd
                        class="mt-1 text-3xl leading-9 font-semibold text-indigo-600"
                      >
                        {{ detail.IND_COLL }}
                      </dd>
                    </dl>
                  </div>
                </div>
                <div class="bg-white overflow-hidden shadow sm:rounded-lg">
                  <div class="px-4 py-5 sm:p-6">
                    <dl>
                      <dt
                        class="text-base leading-5 font-semibold text-gray-800 truncate"
                      >
                        Tarif
                      </dt>
                      <dd
                        class="mt-1 text-3xl leading-9 font-semibold text-red-600"
                      >
                        {{ detail.Tarif }} <span class="text-base">DT</span>
                      </dd>
                    </dl>
                  </div>
                </div>
                <div class="bg-white overflow-hidden shadow sm:rounded-lg">
                  <div class="px-4 py-5 sm:p-6">
                    <dl>
                      <dt
                        class="text-sm leading-5 font-medium text-gray-500 truncate"
                      >
                        Observation
                      </dt>
                      <dd
                        class="mt-1 text-3xl leading-9 font-semibold text-indigo-600"
                      >
                        {{ detail.Observation }}
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="!ListTarif || ListTarif.length == 0">
              <div class="bg-white overflow-hidden shadow sm:rounded-lg">
                <div class="p-3">
                  <img
                    src="../../../assets/no_data/no_data_available1.jpg"
                    alt="data not found"
                  />
                </div>
              </div>
            </ng-container>
          </div>

          <!-- <div
            *ngIf="this.reservationD.TravelD_TypeEvent != 0"
            class="shadow overflow-auto rounded border-b border-gray-200 w-full"
          >
            <div class="flex space-x-4 items-center">
              <span class="text-2xl font-bold mb-16">Tarif</span>
              <a
                class="flex items-center text-lg font-medium mb-16 cursor-pointer text-blue-600 hover:underline"
                (click)="
                  navigateToTarifTable_EasyAcces(this.reservationD.Tiers_code)
                "
                >aller au gestion des tarifs
                <mat-icon class="text-base">launch</mat-icon></a
              >
            </div>
            <table class="w-full bg-white">
              <thead class="bg-gray-800 text-white">
                <tr>
                  <th
                    class="text-left py-3 px-8 uppercase font-semibold text-xs"
                  >
                    Observation
                  </th>

                  <th
                    class="text-left uppercase py-3 px-8 font-semibold text-xs"
                  >
                    Individuel
                  </th>
                  <th
                    class="text-left py-3 px-8 uppercase font-semibold text-xs"
                  >
                    Tarif
                  </th>
                </tr>
              </thead>
              <tbody class="text-gray-700">
                <ng-container *ngFor="let detail of ListTarif; index as i">
                  <tr [class]="i % 2 == 0 ? 'bg-gray-100' : ''">
                    <td class="text-center py-3 px-8">
                      {{ detail.Observation }}
                    </td>
                    <td class="text-center py-3 px-8">
                      {{ detail.IND_COLL }}
                    </td>
                    <td class="text-center py-3 px-8">
                      {{ detail.Tarif }}
                    </td>
                  </tr>
                </ng-container>
                <tr *ngIf="!ListTarif || ListTarif.length == 0">
                  <td
                    colspan="4"
                    class="text-center text-2xl font-bold py-3 px-16"
                  >
                    Pas de données disponibles...!
                  </td>
                </tr>
              </tbody>
            </table>
          </div> -->

          <!-- action sur les standards -->
          <hr class="my-4" />
          <!-- <div class="absolute bottom-0 right-0  gap-4">
          <button (click)="close()" mat-raised-button class="bg-red-600 text-white">
            <mat-icon>fermer</mat-icon>
            Fermer
          </button>
        </div> -->
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #frmVerifyError id="frmVerifyError">
  <div>
    <div class="py-8 w-full">
      <div class="overflow-hidden">
        <div class="flex relative w-fit">
          <div
            class="shadow overflow-auto rounded border-b border-gray-200 w-full"
          >
            <div class="flex justify-between items-center">
              <div class="text-2xl font-bold mb-16">
                Veuillez vérifier la validité et les dates de ces lignes dans le
                tableau des tarifs !
              </div>
              <!-- <button mat-raised-button (click)="supprimerListOfErrors()"  class="bg-red-600 text-white">
                    supprimer tous
                  </button> -->
            </div>
            <table class="w-full bg-white">
              <thead class="bg-gray-800 text-white">
                <tr>
                  <th
                    class="text-left uppercase py-3 px-8 font-semibold text-xs"
                  >
                    Evenement
                  </th>
                  <th
                    class="text-left py-3 px-8 uppercase font-semibold text-xs"
                  >
                    Ville
                  </th>
                  <th
                    class="text-left py-3 px-8 uppercase font-semibold text-xs"
                  >
                    Fournisseur
                  </th>
                  <th
                    class="text-left py-3 px-8 uppercase font-semibold text-xs"
                  >
                    Jour
                  </th>
                  <th
                    class="text-left py-3 px-8 uppercase font-semibold text-xs"
                  >
                    H.debut
                  </th>
                  <th
                    class="text-left py-3 px-8 uppercase font-semibold text-xs"
                  >
                    H.fin
                  </th>
                  <th
                    class="text-left py-3 px-8 uppercase font-semibold text-xs"
                  >
                    durée
                  </th>
                  <th
                    class="text-left py-3 px-8 uppercase font-semibold text-xs"
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody class="text-gray-700">
                <ng-container
                  *ngFor="let errDet of listTravelDToVerifyError; index as i"
                >
                  <tr
                    [class]="
                      i % 2 == 0
                        ? 'bg-gray-100 cursor-pointer hover:bg-blue-100'
                        : 'cursor-pointer hover:bg-blue-100'
                    "
                  >
                    <td
                      class="text-center py-3 px-8"
                      (click)="
                        openInNewTab(
                          'avt/grh/tarif/reservation/' +
                            errDet.Tiers_RS +
                            '/' +
                            errDet.Tiers_code
                        )
                      "
                    >
                      {{ errDet.TravelD_Event }}
                    </td>
                    <td
                      class="text-center py-3 px-8"
                      (click)="
                        openInNewTab(
                          'avt/grh/tarif/reservation/' +
                            errDet.Tiers_RS +
                            '/' +
                            errDet.Tiers_code
                        )
                      "
                    >
                      {{ errDet.TravelD_Ville }}
                    </td>
                    <td
                      class="text-center py-3 px-8"
                      (click)="
                        openInNewTab(
                          'avt/grh/tarif/reservation/' +
                            errDet.Tiers_RS +
                            '/' +
                            errDet.Tiers_code
                        )
                      "
                    >
                      {{ errDet.Tiers_RS }}
                    </td>
                    <td
                      class="text-center py-3 px-8"
                      (click)="
                        openInNewTab(
                          'avt/grh/tarif/reservation/' +
                            errDet.Tiers_RS +
                            '/' +
                            errDet.Tiers_code
                        )
                      "
                    >
                      Jour {{ errDet.TravelD_Jour - 1 }}
                    </td>
                    <td
                      class="text-center py-3 px-8"
                      (click)="
                        openInNewTab(
                          'avt/grh/tarif/reservation/' +
                            errDet.Tiers_RS +
                            '/' +
                            errDet.Tiers_code
                        )
                      "
                    >
                      {{ errDet.TravelD_HDeb }}
                    </td>
                    <td
                      class="text-center py-3 px-8"
                      (click)="
                        openInNewTab(
                          'avt/grh/tarif/reservation/' +
                            errDet.Tiers_RS +
                            '/' +
                            errDet.Tiers_code
                        )
                      "
                    >
                      {{ errDet.TravelD_HFin }}
                    </td>
                    <td
                      class="text-center py-3 px-8"
                      (click)="
                        openInNewTab(
                          'avt/grh/tarif/reservation/' +
                            errDet.Tiers_RS +
                            '/' +
                            errDet.Tiers_code
                        )
                      "
                    >
                      {{ errDet.TravelD_Duree }}
                    </td>

                    <td
                      class="text-center flex flex-row items-center justify-center gap-4"
                    >
                      <!-- <span class="text-lg text-blue-500 hover:text-blue-700 hover:cursor-pointer" (click)="editItem(item)"><i
                                class="far fa-edit"></i></span> -->
                      <span
                        class="text-lg text-red-500 hover:text-red-700 hover:cursor-pointer"
                        (click)="supprimerItemError(errDet)"
                        ><i class="fas fa-trash"></i
                      ></span>
                    </td>
                  </tr>
                </ng-container>
                <tr
                  *ngIf="
                    !listTravelDToVerifyError ||
                    listTravelDToVerifyError.length == 0
                  "
                >
                  <td
                    colspan="4"
                    class="text-center text-2xl font-bold py-3 px-16"
                  >
                    Pas de données disponibles...!
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #frmImpressionPreview>
  <div class="flex justify-center mb-2">
    <button
      (click)="isTarifRapport = false"
      class="rounded-l-md text-left text-white font-semibold text-lg flex items-center shadow-lg"
      [class]="!isTarifRapport ? 'bg-green-800' : 'bg-green-600'"
      style="
        padding-right: 3rem;
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 5px;
      "
    >
      <mat-icon class="mr-6">print</mat-icon>
      Aperçu circuit
    </button>
    <div class="w-2 h-2 bg-white rounded-full"></div>
    <button
      (click)="SetUpImpressionTablePreviewEtatTarifs()"
      class="rounded-r-md text-right text-white font-semibold text-lg flex items-center shadow-lg"
      [class]="isTarifRapport ? 'bg-red-800' : 'bg-red-600'"
      style="
        padding-left: 3rem;
        padding-top: 5px;
        padding-bottom: 5px;
        padding-right: 5px;
      "
    >
      Aperçu tarifs
      <mat-icon class="ml-6">print</mat-icon>
    </button>
  </div>

  <div class="my-2 bg-gray-100 rounded-lg shadow-lg p-2">
    <div *ngIf="isTarifRapport" class="">
      <app-impression
        [isTarifRapport]="true"
        [title]="'Etat des tarifs'"
        [circuitName]="dsReservation.Travel[0].Travel_Nom"
        [numDays]="dsReservation.Travel[0].Travel_NbJour"
        [nbrPeronnes]="dsReservation.Travel[0].Travel_NbPerso"
        [numAccompagnant]="dsReservation.Travel[0].Travel_NbAccompagnant"
        [dateArrivee]="dsReservation.Travel[0].Travel_DateDeb"
        [dateDepart]="dsReservation.Travel[0].Travel_DateFin"
        [reference]="dsReservation.Travel[0].Travel_Ref"
        [TablePreviewEtatTarif]="TableImpressionPreview"
      >
      </app-impression>
    </div>

    <div *ngIf="!isTarifRapport" class="">
      <app-impression
        [isTarifRapport]="false"
        [title]="'Etat de circuit'"
        [circuitName]="dsReservation.Travel[0].Travel_Nom"
        [numDays]="dsReservation.Travel[0].Travel_NbJour"
        [nbrPeronnes]="dsReservation.Travel[0].Travel_NbPerso"
        [numAccompagnant]="dsReservation.Travel[0].Travel_NbAccompagnant"
        [dateArrivee]="dsReservation.Travel[0].Travel_DateDeb"
        [dateDepart]="dsReservation.Travel[0].Travel_DateFin"
        [reference]="dsReservation.Travel[0].Travel_Ref"
        [TablePreviewEtatCircuit]="listeReservationDetail"
      >
      </app-impression>
    </div>
  </div>
</ng-template>
